import { PHANTOM_DEEPLINK_BASE_URL } from '../../phantomRedirect.constants';

export type BuildPhantomDeepLinkParams = {
  appUrl?: string;
  cluster?: string;
  dappPublicKey: string;
  method: string;
  nonce?: string;
  payload?: string;
  redirectUrl: string;
};

/**
 * Builds a Phantom wallet deep link URL for wallet operations.
 *
 * @param params.method - The operation method (connect, signMessage, signTransaction, etc.)
 * @param params.appUrl - Optional dApp URL shown in Phantom's UI
 * @param params.dappPublicKey - The dApp's base58-encoded public encryption key
 * @param params.redirectUrl - The URL to redirect back to after the operation
 * @param params.cluster - Optional Solana cluster (mainnet-beta, devnet, testnet)
 * @param params.payload - Optional encrypted payload for signing operations
 * @param params.nonce - Optional nonce for encrypted payload
 * @returns The complete Phantom deep link URL
 */
export const buildPhantomDeepLink = ({
  appUrl,
  cluster,
  dappPublicKey,
  method,
  nonce,
  payload,
  redirectUrl,
}: BuildPhantomDeepLinkParams): URL => {
  const url = new URL(`${PHANTOM_DEEPLINK_BASE_URL}/${method}`);

  url.searchParams.set('dapp_encryption_public_key', dappPublicKey);
  url.searchParams.set('redirect_link', redirectUrl);

  if (appUrl) {
    url.searchParams.set('app_url', appUrl);
  }

  if (cluster) {
    url.searchParams.set('cluster', cluster);
  }

  if (payload) {
    url.searchParams.set('payload', payload);
  }

  if (nonce) {
    url.searchParams.set('nonce', nonce);
  }

  return url;
};
